import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import StaticStore from '@/store/static'
import Store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter: (to, from, next) => next('/amazonas/skogdekke'), // redirect to default view
    name: 'Home',
    component: Main
  },
  {
    path: '/en',
    beforeEnter: (to, from, next) => next('/amazonas/forestcover'), // redirect to default view
    name: 'EnHome',
    component: Main
  },
  {
    path: '/embed/:region?/:dimension?/:country?',
    name: 'Embed',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/Embed.vue')
  },
  {
    path: '/chart/:id?',
    name: 'Chart',
    component: () => import(/* webpackChunkName: "about" */ '../views/Chart.vue')
  },
  {
    path: '/about',
    name: 'About',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/:region/:dimension?/:country?',
    name: 'main',
    component: Main,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * Every time a route is being accessed, set the values in the store
 * - language
 * - dimension
 * - region
 * - country
 */
router.beforeEach(async (to, from, next) => {
  // if the route has a region, ensure data is loaded for this region
  if (to.params) {
    // first attempt to set the language based on the dimension
    Store.commit('language', to.params.dimension)

    if (to.params.region) {
      await StaticStore.fetch(StaticStore.DIMENSION_FIRE, to.params.region)
      await StaticStore.fetch(StaticStore.DIMENSION_DEFORESTATION, to.params.region)
      await StaticStore.fetch(StaticStore.DIMENSION_FORESTCOVER, to.params.region)

      Store.commit('region', to.params.region)
      // update the dimension in the sore
    }
    if (to.params.dimension) {
      Store.commit('dimension', to.params.dimension)
    }
  }
  // always update country, as missing country means we want it gone
  const country = to.params && to.params.country ? to.params.country : null
  Store.commit('country', country)

  next()
})

export default router
